import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/client/components/chancen-component-card-title.js';
import '@chancenwerk/client/design/components/cr-dropdown-selection.js';
import {
  type MarktAkquiseStatus,
  marktAkquiseStatusColor,
  marktAkquiseStatusText,
} from '@chancenwerk/markt/entities/MarktAkquiseStatus.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement markt-component-status
 */
@customElement('markt-component-status')
export class MarktComponentStatus extends ChemistryLitElement {
  @property() status: Maybe<MarktAkquiseStatus> = null;

  override render() {
    return html`<cr-text
      bold
      ${css({
        padding: this.spacing.sm,
        backgroundColor: marktAkquiseStatusColor(this.status),
        color: 'white',
        borderRadius: this.sizes.borderRadiusSecondary,
        textAlign: 'center',
      })}
    >
      ${marktAkquiseStatusText(this.status ?? 'Leer')}
    </cr-text>`;
  }
}
